import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import pageStore from 'stores/BackInStock/PageStore';
import * as constants from 'Constants';
import * as utils from 'Utils';
import { setFieldValues } from 'stores/Utils';


class SubmittedModalStore {

  @setter @observable display;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.display = false;
  }

  @action show() {
    this.display = true;
  }

  @action hide() {
    if (utils.isPreview()) return;
    this.display = false;
  }
}

const submittedModalStore = new SubmittedModalStore();
export default submittedModalStore;
export { SubmittedModalStore };
